export const MS_IN_SECOND = 1000;

export const SECONDS_IN_MINUTE = 60;
export const MINUTES_IN_HOUR = 60;

export const MS_IN_MINUTE = MS_IN_SECOND * SECONDS_IN_MINUTE;
export const MS_IN_HOUR = MS_IN_MINUTE * MINUTES_IN_HOUR;

export const HOURS_IN_DAY = 24;

export const DAYS_IN_WEEK = 7;

export const DAYS_IN_YEAR = 365;

export const HOURS_IN_YEAR = HOURS_IN_DAY * DAYS_IN_YEAR;
